import PropTypes from 'prop-types';
import React, {Component} from 'react';
import moment from 'moment';

//Utils
import events from '../../../../lib/events.js';
import {formatCurrency} from '../../../helpers/dashboardFormatter.jsx';
import {formatStaticCurrency} from '../../../helpers/currencyHelper.jsx';

//Components
import ReportDropDown from '../components/reportDropDown.jsx';
import PrintableSummary from '../components/printableSummary.jsx';
import Loader from '../../../components/loader.jsx';
import {dateTimeFormats} from 'helpers/constants';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';

//Apis, Uses same endpoints as accountList report
import ReportApi from '../../../../api/report.jsx';
import {makeCancelable} from 'helpers/cancelablePromise';
import ReportSummaryErrorHandler from '../components/reportSummaryErrorHandler';


const filterOptions = {
  branch: -1,
  branchOptions: [],
  poolType: -1,
  poolTypeOptions: [],
};

class NewAccountReport extends Component {
  constructor(props) {
    super(props);
    let {formatMessage} = this.props.intl;

    const _filterOptions = Object.assign({}, filterOptions);
    const branchesFilterable = this.props.branches.map(b => {
      return {
        value: b.id,
        label: b.name,
      };
    });

    _filterOptions.branchOptions = [
      {
        value: -1,
        label: formatMessage({id: 'general.all.stores'}),
      }, ...branchesFilterable];
    _filterOptions.poolTypeOptions = [
      {
        value: -1,
        label: formatMessage({id: 'general.all.systems'}),
      },
      {
        value: 1,
        label: formatMessage({id: 'general.pools'}),
      },
      {
        value: 2,
        label: formatMessage({id: 'general.spas'}),
      },
      {
        value: 3,
        label: formatMessage({id: 'general.swim.spas'}),
      },
    ];
    let year = moment().year();
    const yearOptions = [{label: formatMessage({id: 'general.date.ytd'}, {year}), value: year}];

    year--;
    while (year >= 1986) {
      yearOptions.push({
        label: year,
        value: year,
      });
      year--;
    }
    this.state = {
      loaded: true,
      summary: null,
      report: null,
      year: moment().year(),
      yearOptions,
      start: moment().startOf('year'),
      end: moment().endOf('year'),
      branches: this.props.branches.map(b => b.id),
      showNoDataMessage: false,
      error: false,
      ..._filterOptions,
    };
  }

  componentWillUnmount() {
    this.setState({
      filterOptions: {},
    });

    if (this.fetching && !this.fetching.isFinished) {
      this.fetching.cancel();
    }
  }

  exportReport = () => {
    const {year, branch, poolType} = this.state;
    const start = moment().year(year).startOf('year');
    const end = moment().year(year).endOf('year');

    ReportApi.getNewAccountListExport(this.props.intl.locale,
      start.format(), end.format(),
      branch === -1 ? this.state.branches : branch,
      poolType === -1 ? null : poolType, null, true);
  };

  printReport = () => {
    const {year, summary} = this.state;
    const {TruBlueActive} = this.props;
    let {formatMessage} = this.props.intl;
    const columns = [
      {name: formatMessage({id: 'reports.total.new.accounts'}), key: 'total'},
      {name: formatMessage({id: 'general.total.pools'}), key: 'pools'},
      {name: formatMessage({id: 'general.in.ground.pools'}), key: 'inground'},
      {name: formatMessage({id: 'general.above.ground.pools'}), key: 'aboveground'},
      {name: formatMessage({id: 'general.splasher.pools'}), key: 'splasher'},
      {name: formatMessage({id: 'general.spas'}), key: 'spas'},
      {name: formatMessage({id: 'general.swim.spas'}), key: 'swimspas'},
      {name: formatMessage({id: 'general.total.maintenance'}), key: 'totalMaintenanceSystems'},
    ];

    let truBlueColumns = [
      {name: formatMessage({id: 'reports.new.trublue.accounts'}), key: 'truBlueActive'},
    ];

    if (TruBlueActive) {
      columns.splice(1, 0, ...truBlueColumns);
    }


    let posColumns = [
      {name: formatMessage({id: 'reports.new.purchasing.accounts'}), key: 'posAccounts'},
      {name: formatMessage({id: 'reports.total.purchasing.sales'}), key: 'posSalesSum'},
      {name: formatMessage({id: 'reports.average.new.accounts'}), key: 'posAvgSales'},
    ];
    const tempSummary = Object.assign({}, summary);

    if (this.props.POSActive) {
      columns.push(...posColumns);
      tempSummary.posSalesSum = formatStaticCurrency(tempSummary.posSalesSum);
      tempSummary.posAvgSales = formatStaticCurrency(tempSummary.posAvgSales);
    }

    const date = formatMessage({id: 'general.date.range'}, {
      start: moment().year(year).startOf('year').format(dateTimeFormats.numeralDate),
      end: moment().year(year).endOf('year').format(dateTimeFormats.numeralDate),
    });

    return (
      <PrintableSummary
        columns={columns}
        date={date}
        dateLabel={formatMessage({id: 'general.date'})}
        summary={tempSummary}
        title={formatMessage({id: 'reports.customer.new.accounts'})}
      />
    );
  };

  resetFilters = () => {
    this.setState({
      branch: -1,
      year: moment().year(),
      poolType: -1,
    });
  };

  stateSetter(propName) {
    return value => this.setState({[propName]: value});
  }

  updateReport = () => {
    const {branch, year, poolType} = this.state;
    const start = moment().year(year).startOf('year');
    const end = moment().year(year).endOf('year');

    this.setState({
      loaded: false,
      error: false,
    });

    if (this.fetching && !this.fetching.isFinished) {
      this.fetching.cancel();
    }else{
      this.setState({
        summary: null,
      });
    }

    (this.fetching = makeCancelable(ReportApi.getNewAccountListSummary(start.format(), end.format(),
      branch === -1 ? this.state.branches : branch, poolType === -1 ? null : poolType, null)))
      .then(summary => {
        if (summary && summary.total > 0) {
          this.setState({
            summary: summary,
            start: start,
            end: end,
            showNoDataMessage: false,
            loaded: true,
          });
        } else {
          this.setState({
            start: start,
            end: end,
            loaded: true,
            showNoDataMessage: true});
        }
      }).catch(err => {
        console.log(err);
        if (err && err.canceled) {return;}
        this.setState({loaded: true, error: true});
      });
  };

  render() {
    const {
      year, yearOptions, start, end, summary, loaded,
      branch, branchOptions, poolType, poolTypeOptions, showNoDataMessage,
    } = this.state;
    const {TruBlueActive} = this.props;
    let {formatMessage} = this.props.intl;

    const dateRange = end.year() === moment().year() ?
      <FormattedMessage id='general.present.range.labelled'
                        values={{
                          start: start.format(dateTimeFormats.numeralDate),
                        }} /> :
      <FormattedMessage id='general.date.range.labelled'
                        values={{
                          start: start.format(dateTimeFormats.numeralDate),
                          end: end.format(dateTimeFormats.numeralDate),
                        }} />;


    return (
      <div className='report-container'>
        <span className='description'><FormattedMessage id="reports.new.account.description"/></span>
        <div className="report-options">
          <div className="top-title-bar">
            <FormattedMessage id="general.report.options"/>
          </div>
          <div className="select-options container">
            <div className='row'>
              <div className='col-sm-3'>
                <ReportDropDown value={year}
                                label={formatMessage({id: 'general.year'})}
                                onChange={((e) => {
                                  this.setState({
                                    year: parseInt(e.target.value),
                                  });
                                })}
                                options={yearOptions}/>
              </div>
            </div>
            <div className='row'>
              <div className='col-sm-3'>
                <ReportDropDown value={branch}
                                label={formatMessage({id: 'general.store'})}
                                onChange={((e) => {
                                  this.setState({branch: parseInt(e.target.value)});
                                })}
                                options={branchOptions}/>
              </div>
              <div className='col-sm-3'>
                <ReportDropDown value={poolType}
                                label={formatMessage({id: 'general.system.type'})}
                                onChange={((e) => {
                                  this.setState({poolType: parseInt(e.target.value)});
                                })}
                                options={poolTypeOptions}/>
              </div>
            </div>
          </div>
          <div className='manage-options'>
            <div className='col-sm-12 button-group'>
              <span className='reset-button pull-right'
                    onClick={this.resetFilters}><FormattedMessage id="general.reset"/></span>
              <button className='btn btn-primary pull-right'
                      onClick={this.updateReport}><FormattedMessage id="reports.update.summary"/></button>
            </div>
          </div>
        </div>
        <Loader loaded={loaded}>
          <ReportSummaryErrorHandler error={this.state.error}>
            {summary ? <div className='col-sm-12 summary-container'>
              <div className='row'>
                <h2>
                  <FormattedMessage id="reports.report.summary"/>
                  <span className='summary-date'> | {dateRange}</span>
                </h2>
                <p><FormattedMessage id="reports.reveal.report.summary"/></p>
              </div>
              <div className='row'>
                <div className='col-sm-3 result'>
                  <label><FormattedMessage id="reports.total.new.accounts"/></label>
                  <div>{summary.total}</div>
                </div>
                {TruBlueActive ?
                  <div className='col-sm-3 result'>
                    <label><FormattedMessage id="reports.new.trublue.accounts"/></label>
                    <div>{summary.truBlueActive || '-'}</div>
                  </div> :
                  null}
              </div>
              <div className='row'>
                <div className='col-sm-3 result'>
                  <label><FormattedMessage id="general.total.pools"/></label>
                  <div>{summary.pools}</div>
                </div>
                <div className='col-sm-3 result'>
                  <label><FormattedMessage id="general.in.ground.pools"/></label>
                  <div>{summary.inground}</div>
                </div>
                <div className='col-sm-3 result'>
                  <label><FormattedMessage id="general.above.ground.pools"/></label>
                  <div>{summary.aboveground}</div>
                </div>
                <div className='col-sm-3 result'>
                  <label><FormattedMessage id="general.splasher.pools"/></label>
                  <div>{summary.splasher}</div>
                </div>
                <div className='col-sm-3 result'>
                  <label><FormattedMessage id="general.swim.spas"/></label>
                  <div>{summary.swimspas}</div>
                </div>
                <div className='col-sm-3 result'>
                  <label><FormattedMessage id="general.spas"/></label>
                  <div>{summary.spas}</div>
                </div>
                <div className='col-sm-3 result'>
                  <label><FormattedMessage id="general.total.maintenance"/></label>
                  <div>{summary.totalMaintenanceSystems}</div>
                </div>
              </div>
              {this.props.POSActive &&
              <div className='col-sm-12'>
                <div className='col-sm-3 result'>
                  <label><FormattedMessage id="reports.new.purchasing.accounts"/></label>
                  <div>{summary.posAccounts}</div>
                </div>
                <div className='col-sm-3 result'>
                  <label><FormattedMessage id="reports.total.purchasing.sales"/></label>
                  <div>{formatCurrency(summary.posSalesSum)}</div>
                </div>
                <div className='col-sm-3 result'>
                  <label><FormattedMessage id="reports.average.new.accounts"/></label>
                  <div>{formatCurrency(summary.posAvgSales)}</div>
                </div>
              </div>
              }
            </div> :
            <div className='summary-container'>
              <h2><FormattedMessage id="reports.report.summary"/></h2>
              <p><FormattedMessage id="reports.reveal.report.summary"/></p>
              {showNoDataMessage ?
                <label className="report-no-data"><FormattedMessage id="reports.error.no.results"/></label> : ''}
              <div className="container-fluid custom-container-margins">
                <div/>
              </div>
            </div>}
            <div className='col-sm-12 button-group shift-right'>
              <button className='btn btn-default pull-right'
                    disabled={(summary === null)}
                    onClick={(() => {
                      events.publish('print', this.printReport());
                    })}><FormattedMessage id="reports.print.summary"/></button>
              <button className='btn btn-primary pull-right'
                    onClick={this.exportReport}><FormattedMessage id="reports.export.report"/></button>
            </div>
          </ReportSummaryErrorHandler>
        </Loader>
      </div>
    );
  }
}

NewAccountReport.propTypes = {
  branches: PropTypes.any,
  POSActive: PropTypes.bool,
  TruBlueActive: PropTypes.bool,
};

NewAccountReport.defaultProps = {
  branches: [],
  POSActive: false,
};

export default injectIntl(NewAccountReport);
